import { Card, CardBody, Col, Row } from "reactstrap";
import WizardPanel from "../WizardPanel";
import { PanelField } from "../panelFields";

/**
 * @param {import("../WizardCard").StepPanelProps} props
 *
 * Editable fields for the on-site router credentials.
 */
export default function RouterInfoPanel({ installation, setField, status, bottomNav }) {
  return (
    <WizardPanel
      title="Router Information"
      subtitle="Router access information used for port forwarding configuration"
      status={status}
      bottomNav={bottomNav}
    >
      <Card>
        <CardBody>
          <Row>
            <Col md={6}>
              <PanelField
                label="Brand"
                placeholder="e.g. Orange Livebox"
                value={installation?.router_brand}
                onChange={(v) => setField("router_brand", v)}
              />
            </Col>
            <Col md={6}>
              <PanelField
                label="Local IPv4"
                placeholder="e.g. 192.168.1.1"
                mono
                value={installation?.gateway_ipv4}
                onChange={(v) => setField("gateway_ipv4", v)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <PanelField
                label="MAC address"
                placeholder="e.g. 00:1A:2B:3C:4D:5E"
                mono
                value={installation?.router_mac_address}
                onChange={(v) => setField("router_mac_address", v)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <PanelField
                label="Login"
                placeholder="admin"
                autoComplete="off"
                value={installation?.router_login}
                onChange={(v) => setField("router_login", v)}
              />
            </Col>
            <Col md={6}>
              <PanelField
                label="Password"
                placeholder="Router admin password"
                autoComplete="new-password"
                value={installation?.router_password}
                onChange={(v) => setField("router_password", v)}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </WizardPanel>
  );
}
